/**
 * Web 子项目构建版本：yyyyMMdd + 当日第几次发布（三位，001–999）。
 * 发布前手动递增末三位；跨日则改日期段并归零为 001。
 */
export const BUILD_VERSION = '20260422004';
